import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment as env } from '../../../../environments/environment'



@Injectable({
    providedIn: 'root'
  })

export class ChatService
{
    private _baseChatPath = env.url + env.api_chat;
    private _baseDeskPath = env.url + env.api_desk;
    private _baseSellPath = env.url + env.api_sell;

    constructor(private _httpClient: HttpClient){}
     // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
      * Post chat
      */
    postMenssage(object): Observable<any>
    {
      let params= JSON.stringify(object)
      let headers= new HttpHeaders().set('Content-Type','application/json')
      return this._httpClient.post(this._baseChatPath + 'auth/chats/', params, {headers:headers} );
    }

    /**
      * Get room of the an client with her installer asigned
      */
    getRoom(clientid:number, installerid:number): Observable<any>
    {
       return this._httpClient.get(this._baseSellPath + 'auth/dashboard/room/?clientID='+clientid+'&installerID='+installerid,{params: { use_loading: 'false' } });
    }

    /**
      * Get chat of the an client with her installer asigned
      */
    getChat( room_id:number, page:number): Observable<any>
    {
       return this._httpClient.get(this._baseChatPath + 'auth/chats/?room_id='+room_id+'&page='+page,{params: { use_loading: 'false' } });
    }

    postFileToWhatsapp(file, folder, client_id): Observable<any>
    {

        const formData: FormData = new FormData();
        formData.append('file',file,file.name)
        formData.append('folder', folder)

        return this._httpClient.post(this._baseChatPath + 'auth/chats/' + client_id + '/documents/',formData);
    }
}
